<div class="public-bg">
	<div class="public-content">
		<div class="public-app-logo">
			<img
				src="assets/images/logo.png"
				alt="App-Logo"
				class="is-logo-white" />
		</div>

		@if (componentLoaded | async) {
			<eif-mfa-setup-otp
				#mfaSetUpOtp
				[mfaToken]="mfaData?.MfaToken"
				(confirmSetUpSuccess)="confirmSetUpSuccess()"
				(goBack)="goBack()"></eif-mfa-setup-otp>
		}
	</div>

	<eif-copyright></eif-copyright>
</div>
